module.exports = __webpack_public_path__ + "img/vertical_3_3_9005.817fe11f.png";